//include 21
jQuery(function(){

	var idCounter = 1;

	var privateFunctions = {
		getOrAssignId: function($element){
			var id = $element.attr("id");
			if(!id){
				id = "weather-icon-"+idCounter;
				idCounter++;
				$element.attr("id",id);
			}
			return id;
		},
	}

	var skyconOptions = {
		monochrome:false,
		colors: {
            cloud   : "#22759f",
            rain    : "#22759f",
            sun     : "#FFCC00"
        }
	};

	var initIcons = function($this){
		var skycons = new Skycons(skyconOptions);
		var id = privateFunctions.getOrAssignId($this);
		var weather = $this.data("icon");
		if(!weather)
			return;

		weather = weather.replace('night','day');

		skycons.add(id,weather);
		$this.on("mouseover",function(){
			skycons.play();
		});
		$this.on("mouseout",function(){
			skycons.pause();
		});
	};

	$("canvas.weather-icon").each(function(){
		var $this = $(this);
		initIcons($this);
		/*
		var skycons = new Skycons(skyconOptions);
		var id = privateFunctions.getOrAssignId($this);
		var weather = $this.data("icon");
		if(!weather)
			return;
		skycons.add(id,weather);
		$this.on("mouseover",function(){
			skycons.play();
		});
		$this.on("mouseout",function(){
			skycons.pause();
		});
		*/
	});

	window.pixelpoint.ppComponents.skyCons = {
		init: initIcons
	}

});